// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Tj-2K","title":"styles_title__SIjOG"};